<template>
  <div class="fck-this-backdrop h-100">
    <div class="container-fluid pt-5">
      <div class="row">
        <div class="col-lg-8 offset-2">
          <h1 class="font-weight-bold text-center pt-5" style="color:#707070;">
            Pilih Klinik
          </h1>
          <b-row>
            <b-col
              col
              lg="3"
              class="pt-5"
              v-for="(klinik, index) in kliniks"
              :key="index"
            >
              <label
                @mouseover="klinik.hover = true"
                @mouseleave="klinik.hover = false"
              >
                <input
                  type="radio"
                  v-model="selectedCard"
                  :value="klinik.id"
                  class="card-radio-robot d-none"
                />
                <div class="card card-blue mx-4" v-if="klinik.hover">
                  <center>
                    <img
                      alt="klinik"
                      style="width:75px;"
                      src="/img/klinik_white.png"
                    />
                    <div>
                      <p class="font-weight-bold text-white pt-2">
                        <label v-if="klinik.is_owner">Klinik/HeadOffice</label>
                        <label v-else>Klinik</label>
                      </p>
                      <p class="font-weight-bold text-white">
                        {{ klinik.name }}<br />
                        <small v-if="!klinik.is_owner" class="font-weight-bold">
                          {{
                            klinik.kota_detail == null
                              ? null
                              : klinik.kota_detail.nama
                          }}
                        </small>
                      </p>
                    </div>
                  </center>
                </div>
                <div class="card mx-4" v-else>
                  <center>
                    <img
                      alt="klinik"
                      style="width:75px;"
                      src="/img/klinik_blue.png"
                    />
                    <div>
                      <p class="font-weight-bold text-blue pt-2">
                        <label v-if="klinik.is_owner">Klinik/HeadOffice</label>
                        <label v-else>Klinik</label>
                      </p>
                      <p class="font-weight-bold text-blue">
                        {{ klinik.name }}<br />
                        <small v-if="!klinik.is_owner" class="font-weight-bold">
                          {{
                            klinik.kota_detail == null
                              ? null
                              : klinik.kota_detail.nama
                          }}
                        </small>
                      </p>
                    </div>
                  </center>
                </div>
              </label>
            </b-col>
            <b-col col lg="3" class="pt-5">
              <label
                v-if="showAll != 'all' && klinikUser.length > 3"
                @mouseover="hover = true"
                @mouseleave="hover = false"
              >
                <input
                  type="radio"
                  class="card-radio-robot d-none"
                  value="all"
                  v-model="showAll"
                />
                <div
                  class="card card-blue mx-4 d-flex justify-content-center align-self-center"
                  v-if="hover"
                >
                  <center>
                    <div
                      class="media d-flex justify-content-center align-self-center"
                    >
                      <div class="media-content">
                        <img
                          src="/img/klinik_white.png"
                          alt="klinik"
                          style="height:60px;"
                        />
                      </div>
                      <div
                        class="content-right d-flex justify-content-center align-self-center"
                      >
                        <h1 class="font-weight-bold text-white">
                          + {{ klinikUser.length - 3 }}
                        </h1>
                      </div>
                    </div>
                    <div class="pt-3">
                      <p class="font-weight-bold text-white">
                        Pilih {{ klinikUser.length - 3 }} Klinik <br />
                        Lainnya
                      </p>
                    </div>
                  </center>
                </div>
                <div
                  class="card mx-4 d-flex justify-content-center align-self-center"
                  v-else
                >
                  <center>
                    <div
                      class="media d-flex justify-content-center align-self-center"
                    >
                      <div class="media-content">
                        <img
                          src="/img/klinik_blue.png"
                          alt="klinik"
                          style="height:60px;"
                        />
                      </div>
                      <div
                        class="content-right d-flex justify-content-center align-self-center"
                      >
                        <h1 class="font-weight-bold text-blue">
                          + {{ klinikUser.length - 3 }}
                        </h1>
                      </div>
                    </div>
                    <div class="pt-3">
                      <p class="font-weight-bold text-blue">
                        Pilih {{ klinikUser.length - 3 }} Klinik <br />
                        Lainnya
                      </p>
                    </div>
                  </center>
                </div>
              </label>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      showAll: null,
      selectedCard: null,
      kliniks: [],
      tmpHover: [],
      hover: false
    };
  },
  created() {
    this.card();
    if (this.klinikUser.length < 2)
      this.$router.push({
        name: "home"
      });
  },
  computed: {
    ...mapGetters({
      initPage: "sidebar/initPage",
      getRolesName: "getRolesName",
      klinikUser: "klinikUser"
    })
  },
  watch: {
    selectedCard() {
      this.kliniks.forEach((x, i) => {
        if (this.selectedCard == x.id) this.kliniks[i].hover = true;
        else this.kliniks[i].hover = false;
      });

      this.setKlinik();
    },
    showAll() {
      this.showAll = "all";
      this.card(this.klinikUser.length);
    }
  },
  methods: {
    onlyDokter() {
      return this.getRolesName.length == 1 && this.getRolesName.includes('dokter_klinik');
    },
    card(limit = 2) {
      this.kliniks = [];
      this.klinikUser.forEach((x, i) => {
        if (i <= limit) {
          this.kliniks.push({
            ...x,
            hover: false
          });
        }
      });
    },
    async setKlinik() {
      try {
        const res = await this.$axios.post(
          `user/set-klinik`,
          {
            user_id: this.$store.state.user.id,
            klinik_id: this.selectedCard
          }
        );
        const { status, data } = res.data;

        if (status) {
          this.$store.commit("SET_KLINIK_ID", this.selectedCard);
          this.$store.commit("SET_ROLES", data.roles);
          this.$store.commit("SET_BPJS_AUTH_VALID", data.klinik.bpjs_auth_valid);
          this.$store.commit("SET_SATUSEHAT_AUTH_VALID", data.klinik.satusehat_auth_valid);
          this.$store.commit("SET_BRIDGING_ANTREAN_FKTP", data.klinik.bpjs_config.length > 0);
          
          try {
            this.$store.commit("SET_BRIDGING_ICARE", data.user.dokter[0].dokter_pv_klinik_bpjs.length > 0);
          } catch (error) {
            console.log(error);
          }

          if (this.onlyDokter()) {
            const idKlinikUser = this.$store.getters.getIdKlinikDokter;
            this.$axios
              .get(
                `klinik/dokter/get-by-klinik-user/${idKlinikUser}`
              )
              .then(res => {
                this.$store.commit("SET_DOKTER_ID", res.data.data.id);
              });
          }
          this.$router.push({
            name: "home"
          });
        } else {
          this.$swal({
            text: `Ubah klinik gagal!`,
            type: "warning"
          });
        }
      } catch (err) {
        this.$swal({
          text: `Ubah klinik gagal!`,
          type: "warning"
        });
      }
    }
  }
};
</script>

<style scope="scss">
.fck-this-backdrop {
  background-image: url("~@/assets/img/ubah-klinik.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.card-radio-robot + .card {
  border: 2px solid #3784d9;
  padding: 25px 10px;
  min-width: 175px;
  min-height: 260px;
}

.card-radio-robot + .card:hover {
  cursor: pointer;
}

.card-radio-robot:checked + .card {
  border: 2px solid #3784d9;
  -webkit-transition: border 0.3s;
  -o-transition: border 0.3s;
  transition: border 0.3s;
}

.text-blue {
  color: #3784d9;
}

.card-blue {
  background-color: #3784d9;
}
</style>
